//angular imports
import { computed, signal, WritableSignal } from "@angular/core";
import { ListItem } from "@app/shared";



export abstract class AbstractDepartmentModel {

  public id: string = "";    
  public name: WritableSignal<string>;
  public code: WritableSignal<string>;
  public isActive: WritableSignal<boolean>;
  public isChecked: WritableSignal<boolean>;    
  public fullName = computed(() => this.code() ? `${this.code()} - ${this.name()}` : this.name());
  public hasImageError: WritableSignal<boolean> = signal<boolean>(false);


  constructor()
  {
      this.name = signal<string>(null);
      this.code = signal<string>(null);
      this.isActive = signal<boolean>(false);
      this.isChecked = signal<boolean>(false);
  }


  public select = (val: boolean): void => {
    this.isChecked.set(val);
  };


  public abstract toListItem$?(selected: WritableSignal<boolean>): ListItem<any>;

  public handleImageError(): void {
    this.hasImageError.set(true);
  }

}